
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface CTraderDisconnectedDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  cspAccountId: string | undefined;
}

export function CTraderDisconnectedDialog({
  open,
  onOpenChange,
  cspAccountId,
}: CTraderDisconnectedDialogProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNavigateToCTraderProfile = () => {
    if (cspAccountId) {
      navigate(`/ctrader-profiles/${cspAccountId}`);
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-5 w-5" />
            {t('account_disconnected')}
          </DialogTitle>
          <DialogDescription>
            {t('This account has been disconnected in the Ctrader Profile. Please reconnect in the Ctrader Profile page.')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-start">
          <Button
            type="button"
            variant="default"
            onClick={handleNavigateToCTraderProfile}
            className="w-full sm:w-auto"
          >
            {t('Go to ctrader profile')}
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="w-full sm:w-auto"
          >
            {t('close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
